export const Step = ({ currentStep, children, id }) => {
	return (
		<div style={{ display: id === currentStep ? "block" : "none" }}>
			{children}
		</div>
	);
};
